import React, { useState } from 'react';
import { useReadOnly, useSelected } from 'slate-react';
import { icons } from '@ublend-npm/aulaui-next';

import {
  BrokenFileContainer,
  Failed,
  FailedDescription,
  FailedIcon,
  HoverText,
  ImageContainer,
  ImageFileName,
} from './File.styled';
import { useAulaEditorContext } from '../../EditorContext';
import { Image } from '../Image/Image';

type Props = Omit<
  React.ComponentProps<typeof Image>,
  'isLoaded' | 'isSelected'
> & {
  isCollapsed: boolean;
  name: string;
  entityId: string;
};

export const FileImage = (props: Props) => {
  const { entityId, alt, src, isCollapsed, name } = props;
  const isSelected = useSelected();
  const isReadOnly = useReadOnly();
  const { updateEntity } = useAulaEditorContext();
  const [brokenLink, setBrokenLink] = useState(false);

  if (brokenLink) {
    return (
      <BrokenFileContainer>
        <Failed
          isSelected={isSelected}
          aria-current={isSelected}
          data-testid="broken-link"
        >
          <FailedIcon>
            <icons.ErrorIcon />
          </FailedIcon>
          <FailedDescription>
            Image upload failed due to a network error.
          </FailedDescription>
        </Failed>
      </BrokenFileContainer>
    );
  }

  return (
    <ImageContainer collapsed={isCollapsed} isSelected={isSelected}>
      <Image
        alt={alt || name}
        src={src}
        aria-current={isSelected}
        onError={() =>
          isReadOnly
            ? setBrokenLink(true)
            : updateEntity(entityId, { failed: true })
        }
      />
      <HoverText data-testid="image-description" isSelected={isSelected}>
        {isCollapsed && <ImageFileName>{name}</ImageFileName>}
        {!isCollapsed ? alt || name : alt}
      </HoverText>
    </ImageContainer>
  );
};
